import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@chakra-ui/react';
import { SessionFooter, SplitPane } from '../../';
import { useSelector } from 'react-redux';

const SPLIT_PANE_HEIGHT = '92%';
const FOOTER_HEIGHT = '8%';
const MIN_WIDTH_OPEN = 150;
const MAX_WIDTH_OPEN = 400;

const SplitPaneLayout = ({ children, footerComponents, ...containerProps }) => {
  const isChatHidden = useSelector((state) => state.activeSession.isChatHidden);
  const [openSize, setOpenSize] = useState('20%');
  const onDragFinished = useCallback(
    (size) => {
      if (!isChatHidden) {
        setOpenSize(size);
      }
    },
    [isChatHidden]
  );

  return (
    <Flex flexDirection="column" width="100%" height="100vh" {...containerProps} bgColor="primary">
      <Box height={SPLIT_PANE_HEIGHT} width="100%">
        <SplitPane
          style={{ height: SPLIT_PANE_HEIGHT, width: '100%' }}
          allowResize={!isChatHidden}
          size={isChatHidden ? '48px' : openSize}
          minSize={isChatHidden ? '48' : MIN_WIDTH_OPEN}
          maxSize={isChatHidden ? '48' : MAX_WIDTH_OPEN}
          split="vertical"
          primary="second"
          onDragFinished={onDragFinished}
        >
          {children}
        </SplitPane>
      </Box>
      <SessionFooter height={FOOTER_HEIGHT} {...footerComponents} />
    </Flex>
  );
};

SplitPaneLayout.propTypes = {
  children: PropTypes.any,
  footerComponents: PropTypes.any,
};

SplitPaneLayout.defaultProps = {};

export default SplitPaneLayout;
